<template>
<BaseModal :id="'confirmation-fields-modal'" :title="title" :message="'You are making updates to various daily assignments. Specify if you wish to make updates to the following items'">
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template v-slot:content>
        <form class="col-md-12 p-0" @submit.prevent="form_submit()">
            <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="[]" :for_update="false" :content_align_x="'no-justify'" />
            <div class="modal__buttons text-center text-md-right">
                <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'" />
                <button class="modal__buttons__item" v-html="`Confirm`" />
            </div>
        </form>
    </template>
</BaseModal>
</template>

<style scoped>
.black-label {
    color: black;
}
</style>

<script>
import FormResources from './form_resources'
import FormDynamic from '@/components/FormDynamic.vue'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal from '@/components/BaseModal'

export default {
    name: "FieldsConfirmationModal",

    props: [
        "title",
        "notyf",
        "breadcrumb",
        "form_data"
    ],

    components: {
        FormDynamic,
        Breadcrumb,
        BaseModal,
    },

    data() {
        return {
            form_format: FormResources.confirmation_form_format,
        }
    },

    methods: {

        form_submit() {
            this.$emit('formSubmit', true)
        },

    },

    mounted() {},

};
</script>
